import React from 'react';

const BookedCar = ({ color = '#3A3A3A' }) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.5002 6.75L14.5352 7.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3.4725 7.5L1.5 6.75" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13.6875 10.5H11.8125" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6.1875 10.5H4.3125" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14.5347 7.5L13.9055 4.491C13.7232 3.6225 12.9575 3 12.0695 3H6.00945C5.1387 3 4.38195 3.6 4.18395 4.44825L3.4707 7.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M2.4375 15H4.125C4.746 15 5.25 14.496 5.25 13.875V13.125H12.75V13.875C12.75 14.496 13.254 15 13.875 15H15.5625C16.08 15 16.5 14.58 16.5 14.0625V9.75C16.5 8.50725 15.4928 7.5 14.25 7.5H3.75C2.50725 7.5 1.5 8.50725 1.5 9.75V14.0625C1.5 14.58 1.92 15 2.4375 15Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default BookedCar;